var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallSecondaryBasePiggyBank = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.899 2.283a3.775 3.775 0 0 0-3.77 3.77 3.775 3.775 0 0 0 3.77 3.77 3.784 3.784 0 0 0 3.77-3.77 3.775 3.775 0 0 0-3.77-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.196 8.987-1.57-.27a4.887 4.887 0 0 0-.695-.85 3.333 3.333 0 0 1 1.171-1.93l.09-.077a.44.44 0 0 0 .142-.502.457.457 0 0 0-.425-.309H14.7a2.88 2.88 0 0 0-2.534 1.532c-.167-.013-.322-.026-.476-.026h-1.145a4.682 4.682 0 0 1-4.645 4.169c-1.313 0-2.51-.54-3.359-1.416a4.74 4.74 0 0 0-.424 1.93c0 1.442.669 2.805 1.814 3.693v2.342c0 .245.206.45.45.45h1.815a.444.444 0 0 0 .424-.308l.502-1.506h4.233l.502 1.506c.064.18.232.308.425.308h1.814c.244 0 .45-.205.45-.45v-2.342a4.785 4.785 0 0 0 1.429-1.84l1.312-.527a.452.452 0 0 0 .283-.425V9.424c.013-.218-.154-.399-.373-.437zm-3.539 1.042a.456.456 0 0 1-.45-.45c0-.245.206-.45.45-.45.245 0 .45.205.45.45 0 .244-.205.45-.45.45z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallSecondaryBasePiggyBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-secondary-base-piggy-bank.65df5d28c7ea3608c06ad7171748b067.svg";